import { DomainMappingFull } from "../types/contracts.types";

export const findDomainNameById = (list: DomainMappingFull[], id: string | null): string =>
  list.find((item) => item.id === id)?.domain || "";
